export default __webpack_public_path__ + "static/media/Employee-Summary.46d2a9a6.PNG";